import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetStudent = () => {
    const {
        data: student,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["student"],
        queryFn: () => axiosManager.get$("/student").then((res) => res.data),
    });

    return { student, error, isLoading };
};

export default useGetStudent;
